module.exports = __webpack_public_path__ + "img/icon-trash.9d38e7cb.svg";